import { useAtomValue } from 'jotai'
import { draggingCueAtom } from '../store/dnd.store'
import { useMemo } from 'react'
import { useDroppable } from '@dnd-kit/core'
import { DroppableId, CueDropzone } from '../model/dnd'

/**
 * Dropzone anchored to the last cue of a group, representing "insert after
 * this cue" — the only way to land a cue in the very last slot of a group,
 * since every other dropzone only supports inserting before its target.
 */
export const useCueAfterDropzone = (cueId: string) => {
  const draggingCue = useAtomValue(draggingCueAtom)

  const isDisabled = useMemo(() => {
    const isDraggingGroup = Array.isArray(draggingCue?.children)

    // Groups can't be nested inside another group
    if (isDraggingGroup) return true

    return draggingCue?.id === cueId
  }, [draggingCue?.children, draggingCue?.id, cueId])

  return useDroppable({
    id: DroppableId[CueDropzone.AFTER](cueId),
    disabled: isDisabled,
  })
}
